/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable camelcase */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import { motion } from 'framer-motion';
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { GenerateDate, GenerateDateandTime } from '../../../redux/helper/DateConverter';
import { CamelCase, PriceHandler } from '../../../redux/helper/CamelCase';

function ApprovedOrderList({
    setisPaneOpen,
    DAPList,
    filter,
    handleActivateOrDeactivate,
    OpenPopup,
    setOpenPopup,
    actvloader,
    setactvloader,
    isEditId,
    setisEditId,
    setExportClick,
    isLoaded,
    OrderDetails,
    setOrderDetails,
}) {
    const [searchValue, setsearchValue] = useState('');
    const { email, roles } = JSON.parse(localStorage.getItem('user')).profile;
    const wf_status = {
        0: 'ASE - Unassigned',
        1: 'ASE -  Assigned',
        3: 'RBM - Approval',
        2: 'RBM - Rejected',
        4: 'Distributor - Accepted',
        9: 'Distributor - Declined',
        5: 'BH - Approved',
        6: 'BH - Rejected',
        7: 'CSD - Approved',
        8: 'CSD - Rejected',
        10: 'ASM - Approved',
        11: 'ASM - Rejected',
        12: 'Costing Approved',
        13: 'Costing Rejected',
        14: 'Accountant Approved',
        15: 'Accountant Rejected',
        16: 'TH - Approved',
        17: 'TH - Rejected',
        18: 'TDC - Approved',
        19: 'TDC - Rejected',
        20: 'Plant Quality Approved',
        21: 'Plant Quality Rejected',
    };

    const order_status = {
        0: 'Draft',
        1: 'Pending',
        2: 'InProcess',
        3: 'Approved',
        4: 'Out for delivery',
        5: 'Partially Delivered',
        6: 'Deliverd',
        7: 'Completed',
        8: 'Rejected',
        '-1': 'Draft',
    };

    const payment_status = {
        0: 'Pending',
        1: 'Partial',
        2: 'Paid',
    };

    const SerachUser = (val) => {
        if (searchValue === '') {
            return val;
        }
        if (val.email.toLowerCase().includes(searchValue.toLowerCase())) {
            return val;
        }
    };
    return (
        <tbody>
            {DAPList?.filter((val) => SerachUser(val)).map((user, i) => (
                <motion.tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]" key={i}>
                    <td
                        className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4 bg-[#ffffffe6]"
                        // style={{ backgroundColor: 'rgba(255, 255, 255, 0.45)', backdropFilter: blur('5.5px') }}

                    >
                        {user?.order_initial_number}
                    </td>
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                        {user?.order_number}
                    </td>
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                        {user?.order_acceptance_number || '-'}
                    </td>
                    <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                        {GenerateDateandTime(user?.created_at)}
                    </td>
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                        {user?.po_number || '-'}
                    </td>
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                        {user?.order_type}
                    </td>
                    <td className="text-sm font-normal py-2.5 px-7 text-center">
                        {user?.total_items}
                    </td>
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                        {order_status[user?.status]}
                    </td>
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-end">
                        {PriceHandler(user?.total_price)}
                    </td>
                    {(Object.keys(user?.plant_info || {}).length) > 0
                        ? (
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                {user?.plant_info.DESCRIPTION}
                            </td>
                        ) : (
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                -
                            </td>
                        )}
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                        {user?.distributor_company_name}

                    </td>
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                        {user?.distributor_type}
                    </td>
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                        {user?.initial_category === '' ? '-' : user?.initial_category}
                    </td>
                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                        {wf_status[user?.work_flow_status]}
                    </td>
                    <td
                        className="py-2.5 px-7 sm:sticky right-0 z-50 bg-[#ffffffe6]"
                        // style={{ backgroundColor: 'rgba(255, 255, 255, 0.45)', backdropFilter: blur('5.5px') }}

                    >
                        <div className="flex items-center">
                            <Link
                                to={user.status === -1 ? `/manage-orders/direct-order/${user.distributor_id}/${user.order_number}/edit/cart` : `/manage-orders/${user.distributor_id}/${user.order_number}/view`}
                                style={user.status === -1 && user.initiator !== email ? { pointerEvents: 'none' } : null}
                            >
                                <button
                                    type="button"
                                    className="text-[#fff]"
                                    // className="font-semibold text-sm text-[#303030] bg-[#A5A5A5] rounded-lg w-[72px] h-[34px]"
                                    style={{
                                        background: '#44445E',
                                        padding: '5px 10px',
                                        borderRadius: '4px',
                                    }}
                                    data-testid={`view-btn-${i}`}
                                >
                                    {user.status === -1 ? user.initiator !== email ? 'Draft' : 'Edit' : 'View'}
                                </button>
                            </Link>
                            {user.status === -1
                            && user.initiator === email && (
                                <button
                                    type="button"
                                    className="text-[#fff] ml-3"
                                    onClick={() => setOrderDetails(user)}
                                    // className="font-semibold text-sm text-[#303030] bg-[#A5A5A5] rounded-lg w-[72px] h-[34px]"
                                    style={{
                                        background: '#44445E',
                                        padding: '5px 10px',
                                        borderRadius: '4px',
                                    }}
                                >
                                    Cancel
                                </button>
                            )}
                        </div>
                    </td>
                </motion.tr>
            ))}
        </tbody>
    );
}

export default ApprovedOrderList;
